export const wrapperStyle = (isMobile?: boolean): React.CSSProperties => ({
  width: isMobile ? '80%' : '100%',
  flexWrap: 'wrap',
});

export const breakWordStyle = (isMobile?: boolean): React.CSSProperties => ({
  wordWrap: 'break-word',
  width: isMobile ? '100%' : 'auto',
});

export const fontWeightNormal = { fontWeight: 400 };
